import React, { useState } from "react";
import {
  CustomInput,
  Nav,
  NavItem,
  Button,
  TabContent,
  TabPane,
  Alert,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { setBaseMap, setCitra, setHollowMaps } from "~/redux/actions";
import { TIPE_PETA } from "~/utils";
import FilteredPeta from "./filtered-peta";

const TabPeta = ({ children, handleSwitchMode }) => {
  const [activeTab, setActiveTab] = useState("1");

  const { citra, legends, bidangLayer, hollowMaps, activeList } = useSelector(
    (state) => state.Map
  );

  const dispatch = useDispatch();

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <section>
      <Nav className="pr-2 pl-2 mb-2 mt-3 align-items-center">
        <NavItem>
          <Button
            color="link"
            className={activeTab === "1" && "border border-primary"}
            onClick={() => toggle("1")}
          >
            <i className="mdi mdi-layers-outline" />
          </Button>
        </NavItem>
        <NavItem>
          <Button
            color="link"
            className={activeTab === "2" && "border border-primary"}
            onClick={() => toggle("2")}
          >
            <i className="mdi mdi-map-legend" />
          </Button>
        </NavItem>

        <NavItem>
          <Button
            color="link"
            className={activeTab === "3" && "border border-primary"}
            onClick={() => toggle("3")}
          >
            <i className="mdi mdi-information-outline" />
          </Button>
        </NavItem>

        {handleSwitchMode && (
          <NavItem className="ml-auto">
            <CustomInput
              type="switch"
              name="customSwitch"
              disabled={!activeList}
              id="exampleCustomSwitch"
              onChange={handleSwitchMode}
            />
          </NavItem>
        )}
      </Nav>

      <TabContent className="p-0" activeTab={activeTab}>
        <TabPane tabId="1">
          <section className="pb-2 mode-edit" />
          <div
            className="pr-2 pl-2 mb-3 pb-5"
            style={{ height: "calc(100vh - 120px)", overflow: "auto" }}
          >
            {bidangLayer === TIPE_PETA.BIDANG && (
              <>
                <Alert color="primary">
                  <i className="mdi mdi-information-outline mr-2" />
                  Lihat peta bidang
                </Alert>
                <div className="mb-3">
                  <FilteredPeta />
                </div>
              </>
            )}

            <Alert color="primary">
              <i className="mdi mdi-information-outline mr-2" />
              Basemap
            </Alert>

            <div className="mt-3">
              <CustomInput
                className="mb-3"
                type="radio"
                name="google"
                id="googlemap"
                label="Google Map"
                defaultChecked
                onChange={(e) => dispatch(setBaseMap(e.target.id))}
              />
              <CustomInput
                className="mb-3"
                type="radio"
                name="google"
                id="googlesatelite"
                label="Google Satelite"
                onChange={(e) => dispatch(setBaseMap(e.target.id))}
              />
            </div>

            <Alert color="primary">
              <i className="mdi mdi-information-outline mr-2" />
              Maps
            </Alert>

            <div className="mt-3">
              <CustomInput
                className="mb-3"
                type="checkbox"
                name="citra"
                id="citra"
                label="Citra"
                defaultChecked={citra}
                onChange={(e) => dispatch(setCitra(e.target.checked))}
              />

              <CustomInput
                className="mb-3"
                type="checkbox"
                name="hollow_maps"
                id="hollow_maps"
                label="Hollow Maps"
                defaultChecked={hollowMaps}
                onChange={(e) => dispatch(setHollowMaps(e.target.checked))}
              />
            </div>
          </div>
        </TabPane>

        <TabPane tabId="2">
          <section className="pb-2 mode-edit" />
          <div className="pr-2 pl-2 mb-3">
            <Alert color="primary" className="mb-3">
              <i className="mdi mdi-information-outline mr-2" />
              Legenda
            </Alert>

            {legends?.map((legend, idx) => (
              <div
                key={`${legend.ket_color}-${idx}`}
                className="d-flex align-items-center mx-auto mb-3"
              >
                <span
                  style={{
                    position: "relative",
                    width: "10%",
                    height: "15px",
                    backgroundColor: legend.warna,
                  }}
                />
                <span className="ml-2">{legend.ket_color}</span>
              </div>
            ))}
          </div>
        </TabPane>

        <TabPane tabId="3">{children}</TabPane>
      </TabContent>
    </section>
  );
};

export default TabPeta;
